


import { reduxForm , handleSubmit, FieldArray,Field, startSubmit, formValueSelector} from 'redux-form'
import {SVRDFORM,SV_SERVICES, SV_SERVER_ADDRESS, SV_URL} from '../../../constants'
import { Icon, Button as SVAButton, Row, Col, Badge } from 'antd';
import {loadGeo } from '../../../redux/svractions/svreguserdetActions'
import {Link} from 'react-router-dom';

const {connect}  = require("react-redux")


const React = require('react')


const svsubmit =(values)=>{
    let me = this
  console.log('sv submit callback')
  console.log(values)
/*

  Promise.all([svNotifySavePromise(values)]).then((ar)=>{
      console.log('sv got promise data')

      let rs= ar[0]
      console.log(rs)
        if(rs.data.value.payload.gene){
           // me.props.geneReceptorActivate(rs.data.value.payload.gene, rs.data.value.payload)
        }
   

  })
  */
  //this.props.handleSubmit(this.props.submit('SVClassifierForm'))
}
const isdcodeTypes = [{
    name:'United States Of America(+1)',
    value:'+1'
  },{
    name:'Australia(+61)',
    value:'61'
},{
    name:'Spain(+34)',
    value:'34'
  }]

const renderField = ({
    input,
    label,
    type,
    meta: { asyncValidating, touched, error }
  }) => (
    
     
      
      <div className={asyncValidating ? 'async-validating' : ''}>
          
        <input className="form-control" {...input} type={type} placeholder={label} />
        {touched && error && <span className="sv-form-err" >{error}</span>}
      </div>
   
  )
  const renderFieldDup = ({
    input,
    label,
    type,
    meta: { asyncValidating, touched, error }
  }) => (
    
     
      
      <div className={asyncValidating ? 'async-validating' : ''}>
          {touched && error &&  <input className="sverr form-control" {...input} type={type} placeholder={label} /> }
          {touched && !error &&  <input className="svgreen form-control" {...input} type={type} placeholder={label} /> }
        <input className="form-control" {...input} type={type} placeholder={label} />
        {touched && error && <span className="sv-form-err" >{error}</span>}
      </div>
   
  )
  /*
const renderSelectList = ({ input, data }) => (
    <SelectList {...input} onBlur={() => input.onBlur()} data={data} />
  )
  const renderTravelSelectList = ({ input, data }) => (
    <SelectList {...input} onBlur={() => input.onBlur()} data={data} />
  )

  const renderBookingAgentType = ({input, data})=> (
      <SelectList {...input } onBlur={() =>input.onBlur()} data={data} />
  )

*/
let genes = [{
    name:'add_step',
    value:'add_step'

  },{
    name:'multiply_seq_step',
    value:'multiply_seq_step'
  },{

    name:'sq_step',
    value:'sq_step'
},{
    name:'sr_step',
    value:'sr_step'
  
  }]


let svChange = (values, dispatch, props, valuesPrev)=>{

    console.log('sv form change')
  
    console.log(values)
  
  
  }


let validate =(formData)=>{
    console.log('sv--valudare fprmData')
      console.log(validate)
        const errors={}
        if(!formData){
            console.log('validate: sv formData null issue')
            return errors
        }
       
        if(!formData.fname){
            errors.fname= 'Required'
        }
        if(!formData.lname){
            errors.lname= 'Required'
        }
        if(!formData.password){
            errors.password= 'Required'
        }
        if(!formData.passwordmirror){
            errors.passwordmirror= 'Required'
        }
        if(!formData.email){
            errors.email= 'Required'
        }
      
        if(!formData.isdcode){
            errors.isdcode= 'Required'
        }
        if(!formData.phone){
            errors.phone= 'Required'
        }
       
        return errors
    
    }
    
    let warn= (formData)=>{
        const o = {}
        if(!formData){
            console.log('sv gene null issue')
            return o
        }
        /*
        if(formData.lname <2){
            o.gene ='We expect gene to br more tham 5'
        }
        */
        return o
    }


class CreateReguserFormFormBus extends React.Component{

    componentWillMount()	{
        console.log('sv--CreateReguserFormFormBus=---  componentWillMount SVFEB19 geo link sends us params')
        console.log(this.props)
        this.props.load()
    }
    constructor(props){
        
        super(props)
        let me = this
        this.loadGene = this.loadGene.bind(this)
        
        this.cancelPage = this.cancelPage.bind(this) 
       
       
    }
    

    
    cancelPage(){
        console.log('cancel page')

    }
 loadGene(e){
        console.log(e)
    }


    
    
    render(){
        console.log('sv... SVCDnaStepFormBus 2')
        const { handleSubmit, pristine, error,reset, submitting } = this.props
        //const { initialValues,load, handleSubmit,loadGeneTemplate,  pristine, reset, submitting, submit, startSubmit } = this.props 
       // const { id, gene} = initialValues
        const me = this 
        //me.gene = gene
        let initialValues = this.props.initialValues
        const {countryTypes, isdcodeTypes} = this.props.my_data_geo
       
        console.log(this.props)

        const {det} = this.props
        
        if(det && det.phone.length > 0){
            initialValues = det
        }


        return (
            <div>
                    <form  onSubmit={handleSubmit}>
                            <div className="rev-row">
                                <div className="card card--raised with-shadow">
                                    <p className="right-sd-content"> <text> Enter Details Now </text></p>

                                        <div className="form-group">
                                            <label htmlFor="id"> ID</label>
                                            
                                                <Field
                                            
                                                id="id"
                                                    name="id"
                                                    type="text"
                                                    placeholder="id"
                                                    component="input"
                                                    className="form-control"
                                                />
                                            

                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="fname"> First Name</label>
                                            
                                                <Field
                                            
                                                    id="fname"
                                                    name="fname"
                                                    type="text"
                                                    placeholder="John"
                                                    component={renderField}
                                                    className="form-control"
                                                />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="lname"> Last Name</label>
                                            <Field
                                                    id="lname"
                                                    name="lname"
                                                    type="text"
                                                    placeholder="Glen"
                                                    component={renderField}
                                                    className="form-control"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="email"> Email Address</label>
                                            <Field
                                                    id="email"
                                                    name="email"
                                                    type="text"
                                                    placeholder="john123@yahoo.com"
                                                    component={renderField}
                                                    className="form-control"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="password"> Password </label>
                                            <Field
                                                    id="password"
                                                    name="password"
                                                    type="text"
                                                    placeholder="Pete123"
                                                    component={renderField}
                                                    className="form-control"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="passwordmirror"> Confirm Password </label>
                                            <Field
                                                    id="passwordmirror"
                                                    name="passwordmirror"
                                                    type="text"
                                                    placeholder="Pete123"
                                                    component={renderField}
                                                    className="form-control"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="city"> UserId</label>
                                            <Field
                                                    id="username"
                                                    name="username"
                                                    type="text"
                                                    placeholder="Pet123@ayhoo.com"
                                                    component={renderField}
                                                    className="form-control"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="encpassword"> Encryptes Password</label>
                                            <Field
                                                    id="encpassword"
                                                    name="encpassword"
                                                    type="text"
                                                    placeholder="95648"
                                                    component={renderField}
                                                    className="form-control"
                                            />
                                        </div>
                                        <div className="form-group">
                                                <label htmlFor="isdcode" > ISD Code</label>
                                                <Field  component="select" id="isdcode"   name="isdcode"  className="form-control" >
                                                
                                                <option value="">Select PhoneCalling /ISD Code</option>
                                                    {
                                        
                                                
                                        isdcodeTypes.map(  (o, idx)=>(  <option value={o.name+'('+o.value+')'} key={o.name}>{o.name}</option>)
                                                    
                                                    
                                                    
                                                
                                                )}
        
                                                    </Field>
                                        </div>
                                        {/*  
                                        <div className="form-group">
                                            <label htmlFor="isdcode"> ISD Code</label>
                                            <Field
                                                    id="isdcode"
                                                    name="isdcode"
                                                    type="text"
                                                    placeholder="+1"
                                                    component="input"
                                                    className="form-control"
                                            />
                                        </div>
                                        */}
                                        <div className="form-group">
                                            <label htmlFor="phone"> Phone</label>
                                            <Field
                                                    id="phone"
                                                    name="phone"
                                                    type="text"
                                                    placeholder="916-645-6360"
                                                    component={renderField}
                                                    className="form-control"
                                            />
                                        </div>
                                    </div>
                            </div>

                            <div>
                            <SVAButton style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" >
                                <Link to={`/svhome`}> SVRegCancel   </Link>
                            </SVAButton>
        
               <button type="submit" className="btn btn-success" disabled={pristine || error || submitting}>
          Save(CreateOrModify)
        </button>   
         </div>
                    </form>
            </div>
        )
                    
                    

    }
}


/*
const selector = formValueSelector(SVRDFORM)
*/
/*
let svChange = (values, dispatch, props, valuesPrev)=>{

    console.log('sv form change')
  
    console.log(values)
  
  
  }
  */

const rdForm  = reduxForm({
    form:SVRDFORM,
    validate:validate,
   
    warn:warn,
    //onSubmit:svsubmit,
    onChange:svChange,
    enableReinitialize:true,
    keepDirtyOnReinitialize:true

})(CreateReguserFormFormBus)
let CreateReguserFormBusCom =connect((state=>{
    const { svreguserdetView} = state
    let plucked = state.movies  
    console.log('FEB19 my_data_reguserdet', svreguserdetView)
    console.log('FEB19Nmy_data_geo', svreguserdetView.my_data_geo)
    //let o = {initialValues:plucked.adData }
    let o = {initialValues:svreguserdetView.my_data_reguserdet, my_data_geo:svreguserdetView.my_data_geo}
    console.log('sv*******************CrateAddressForm shoul getmy_data_addressdet start ')
    
    //selector(state, 'id')
    console.log('sv info')
    console.log(o)
    console.log('sv*******************CrateAddressForm shoul getmy_data_addressdet end ')
    
    return o
   // return plucked.adData
}),{
    load:loadGeo,
    startSubmit:startSubmit
   
   // loadGeneTemplate:loadGeneTemplate

    
})(rdForm)

/* 
let CreateReguserFormBusCom =connect((state=>{
    const { svreguserdetView} = state
    let plucked = state.movies  
    console.log('FEB19 my_data_reguserdet', svreguserdetView)
    console.log('FEB19Nmy_data_geo', svreguserdetView.my_data_geo)
    //let o = {initialValues:plucked.adData }
    let o = {initialValues:svreguserdetView.my_data_reguserdet, my_data_geo:svreguserdetView.my_data_geo}
    console.log('sv*******************CrateAddressForm shoul getmy_data_addressdet start ')
    
    //selector(state, 'id')
    console.log('sv info')
    console.log(o)
    console.log('sv*******************CrateAddressForm shoul getmy_data_addressdet end ')
    
    return o
   // return plucked.adData
}),{
    load:loadGeo,
    startSubmit:startSubmit
   
   // loadGeneTemplate:loadGeneTemplate

    
}, null, {withRef:false})(rdForm)

*/
export default CreateReguserFormBusCom
//const CreateAddressFormFormBusCom  =x